import { IWholesalerCatalog } from '@cbgms/api'
import useQuery from '@cbgms/base/http/use-query'
import { useDispatch } from 'react-redux'
import { loadWholesalerCatalogs } from '../state/actions'
import { wholesalerCatalogsCacheKey } from './cache-keys'

export const useGetWholesalerCatalog = (wholesalerUUID?: string, onSuccess?: (data: IWholesalerCatalog[]) => void) => {
  const dispatch = useDispatch()

  return useQuery(
    wholesalerCatalogsCacheKey(wholesalerUUID || ''),
    async () => {
      if (wholesalerUUID) {
        const { Data } = await dispatch(loadWholesalerCatalogs(wholesalerUUID))
        return Data
      }
      return null
    },
    { onSuccess, refetchOnWindowFocus: false }
  )
}
